import React, { FC } from "react";

import ScheduleList from "./../../components/Schedule/ScheduleList";

const ScheduleListPage: FC = () => <ScheduleList />;

export default ScheduleListPage;
